import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Images from "../../assets/index";
import logo from "../../../common/assets/img/logo.png";
import Strings from "../../res/String";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/Actions";

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const values = useSelector((state) => state.loginData);

  const handlerLogout = () => {
    dispatch(logout());
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  // Set initial open menus based on path
  const getInitialOpenMenus = (path) => ({
    business: [
      "/",
      "/agentManagement",
      "/newPackingList",
      "/forwardCover",
    ].some((p) => path.startsWith(p)),
    customers: ["/addCustomer", "/viewCustomer"].some((p) =>
      path.startsWith(p)
    ),
    userManagement: ["/addUser", "/userManagement"].some((p) =>
      path.startsWith(p)
    ),
  });

  const [openMenus, setOpenMenus] = useState(
    getInitialOpenMenus(location.pathname)
  );

  // Update menu state when path changes
  useEffect(() => {
    setOpenMenus((prevState) => ({
      ...prevState,
      ...getInitialOpenMenus(location.pathname),
    }));
  }, [location.pathname]);

  // Toggle a single menu without closing others
  const toggleMenu = (menuName) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [menuName]: !prevState[menuName],
    }));
  };

  return (
    <>
      <button
        className={isOpen ? "hamburger-icon" : "hamburger_icon"}
        onClick={() => setIsOpen(!isOpen)}
      >
        <img
          src={isOpen ? Images?.closeWhiteIcon : Images?.hamburgerIcon}
          style={{ width: "23px", height: "23px" }}
          alt="menu-toggle"
        />
      </button>

      <div className={`sidebar${isOpen ? " open" : ""}`}>
        <div
          style={{ width: "100%", height: "120px" }}
          className="d-flex align-items-center"
        >
          <a href="/" className="text-decoration-none sidebar_logo">
            <img
              src={logo}
              alt="Best Timbers"
              style={{ width: "100%", height: "100%" }}
            />
          </a>
          <hr />
        </div>

        {(values?.role === "superAdmin" || values?.role === "admin") && (
          <ul className="sidebar_list_block">
            {/* BUSINESS */}
            <li>
              <h5
                className="list_items_menubar"
                onClick={() => toggleMenu("business")}
                style={{
                  backgroundColor: openMenus.business
                    ? "#74512d"
                    : "transparent",
                  color: openMenus.business ? "#ffffff" : "",
                }}
              >
                BUSINESS
              </h5>
              {openMenus.business && (
                <ul className="sidebar_list_block">
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/" ? "active-submenu" : ""
                    }`}
                  >
                    <Link to="/">DATA MANAGEMENT</Link>
                  </li>
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/agentManagement"
                        ? "active-submenu"
                        : ""
                    }`}
                  >
                    <Link to="/agentManagement">AGENT MANAGEMENT</Link>
                  </li>
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/newPackingList"
                        ? "active-submenu"
                        : ""
                    }`}
                  >
                    <Link to="/newPackingList">NEW PACKING LIST</Link>
                  </li>
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/forwardCover"
                        ? "active-submenu"
                        : ""
                    }`}
                  >
                    <Link to="/forwardCover">FORWARD COVER</Link>
                  </li>
                </ul>
              )}
            </li>

            {/* CUSTOMERS */}
            <li>
              <h5
                className="list_items_menubar"
                onClick={() => toggleMenu("customers")}
                style={{
                  backgroundColor: openMenus.customers
                    ? "#74512d"
                    : "transparent",
                  color: openMenus.customers ? "#ffffff" : "",
                }}
              >
                CUSTOMERS
              </h5>
              {openMenus.customers && (
                <ul className="sidebar_list_block">
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/addCustomer"
                        ? "active-submenu"
                        : ""
                    }`}
                  >
                    <Link to="/addCustomer">ADD CUSTOMER</Link>
                  </li>
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/viewCustomer"
                        ? "active-submenu"
                        : ""
                    }`}
                  >
                    <Link to="/viewCustomer">VIEW CUSTOMER</Link>
                  </li>
                </ul>
              )}
            </li>

            {/* USER MANAGEMENT */}
            <li>
              <h5
                className="list_items_menubar"
                onClick={() => toggleMenu("userManagement")}
                style={{
                  backgroundColor: openMenus.userManagement
                    ? "#74512d"
                    : "transparent",
                  color: openMenus.userManagement ? "#ffffff" : "",
                }}
              >
                USER MANAGEMENT
              </h5>
              {openMenus.userManagement && (
                <ul className="sidebar_list_block">
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/addUser" ? "active-submenu" : ""
                    }`}
                  >
                    <Link to="/addUser">NEW USER</Link>
                  </li>
                  <li
                    className={`list_items_submenubar ${
                      location.pathname === "/userManagement"
                        ? "active-submenu"
                        : ""
                    }`}
                  >
                    <Link to="/userManagement">VIEW USER</Link>
                  </li>
                </ul>
              )}
            </li>

            {/* LOGOUT */}
            <li className="nav-items" onClick={handlerLogout}>
              <div className="nav-label">LOGOUT</div>
            </li>
          </ul>
        )}

        {/* LIMITED ADMIN */}
        {values?.role === "limitedAdmin" && (
          <ul
            className="nav nav-pills flex-column mb-auto"
            style={{ width: "100%" }}
          >
            <li>
              <NavLink to="/" className="nav-label d-block" aria-current="page">
                PKL MANAGEMENT
              </NavLink>
            </li>
            <li className="nav-items" onClick={handlerLogout}>
              <div className="nav-label">LOGOUT</div>
            </li>
          </ul>
        )}
      </div>
    </>
  );
}
